import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { RouterModule } from '@angular/router';
import {
  getDeepFromObject,
  NbAuthJWTToken,
  NbAuthModule,
  NbPasswordAuthStrategy,
  NbPasswordAuthStrategyOptions,
  NbTokenLocalStorage,
  NbTokenStorage,
} from '@nebular/auth';
import {
  NbAlertModule,
  NbButtonModule,
  NbCardModule,
  NbInputModule,
  NbLayoutModule,
  NbSidebarModule,
} from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { MaterialModule } from '../material/material.module';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthComponent } from './auth.component';
import { ExternalRegistrationFormComponent } from './external-registration-form/external-registration-form.component';
import { LoginComponent } from './login/login.component';
import { AppAuthService } from './services/app-auth.service';
import { AuthGuard } from './services/auth-guard';
import { PasswordInputComponent } from './external-registration-form/password-input/password-input.component';
import { CountryInputComponent } from './external-registration-form/country-input/country-input.component';
import { B2bRegistrationFormComponent } from './external-registration-form/b2b-registration-form/b2b-registration-form.component';
import { B2cRegistrationFormComponent } from './external-registration-form/b2c-registration-form/b2c-registration-form.component';

export const getTokenEmailStrategy = (
  // @ts-ignore
  module: string,
  res: HttpResponse<any>,
  options: NbPasswordAuthStrategyOptions) => getDeepFromObject(res.body, options.token.key);

export const enum StrategyNames {
  extern = 'external_user_email',
}

const NB_AUTH_PROVIDERS = [
    { provide: NbTokenStorage, useClass: NbTokenLocalStorage },
    ...NbAuthModule.forRoot({

    strategies: [
      NbPasswordAuthStrategy.setup({
        name: StrategyNames.extern,
        baseEndpoint: environment.exchangeApi.url,
        login: {
          endpoint: 'authentication_token',
          method: 'post',
          requireValidToken: false,
          redirect: {
            success: AppAuthService.defaultPage,
            failure: null,
          },
        },
        register: {
          endpoint: 'external_members',
        },
        token: {
          class: NbAuthJWTToken,
          key: 'token',
          getter: getTokenEmailStrategy,
        },
        validation: {
          fullName: {
            required: false, // Default, the user registration form waiting for a "fullName" property that we don't want
          },
        },
      }),
    ],
  }).providers,
  AuthGuard,
  AppAuthService,
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    AuthRoutingModule,
    NbLayoutModule,
    NbCardModule,
    NbSidebarModule, // NbSidebarModule.forRoot(), //if this is your app.module
    NbButtonModule,
    NbAlertModule,
    NbInputModule,
    TranslateModule,
    NbAuthModule,
    MaterialModule,
    MatRadioModule,
  ],
  declarations : [
    AuthComponent,
    LoginComponent,
    ExternalRegistrationFormComponent,
    PasswordInputComponent,
    CountryInputComponent,
    B2bRegistrationFormComponent,
    B2cRegistrationFormComponent,
  ],
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        ...NB_AUTH_PROVIDERS,
      ],
    } as ModuleWithProviders<AuthModule>;
  }
}
